window.quizData = {
  goddesses: {
    athena: {
      name: "Athena",
      keywords: ["Wisdom", "Clarity", "Inner Authority"],
      image: "goddess-athena-hero.webp",
      medallionImage: "athena-medallion.webp",
      aboutYouImage: "goddess-athena-about-you.webp",
      aboutGoddessImage: "goddess-athena-about-goddess.webp",
      productGoldHandle: "bellissima-athena-necklace",
      productSilverHandle: "athena-necklace-silver",
      productGoldUrl: "https://apolloniajewelry.com/products/bellissima-athena-necklace?variant=55990253748601",
      productSilverUrl: "https://apolloniajewelry.com/products/athena-necklace-silver?variant=55996836479353",
      productGoldVariantId: "55990253748601",
      productSilverVariantId: "55996836479353",
      productGoldLabel: "Gold",
      productSilverLabel: "Silver",
      aboutYou: "You don’t react — you understand. You take a step back, read the situation, and choose your next move with intention. There is something about you that feels composed, grounded, and self-contained. You don’t give your energy away easily, and when you do, it’s deliberate.",
      aboutGoddess: "Athena is the embodiment of clarity, intelligence, and self-trust. She doesn’t chase or force — she observes, understands, and acts at the right moment. Her power is not loud, but it is undeniable. When you align with this energy, you move through life with certainty, not confusion.",
      resultIntro: "You move through life with clarity, precision, and quiet authority."
    },

    persephone: {
      name: "Persephone",
      keywords: ["Depth", "Intuition", "Transformation"],
      image: "goddess-persephone-hero.webp",
      medallionImage: "persephone-medallion.webp",
      aboutYouImage: "goddess-persephone-about-you.webp",
      aboutGoddessImage: "goddess-persephone-about-goddess.webp",
      productGoldHandle: "persephone-necklace",
      productSilverHandle: "persephone-necklace-silver",
      productGoldUrl: "https://apolloniajewelry.com/products/persephone-necklace?variant=55992555340153",
      productSilverUrl: "https://apolloniajewelry.com/products/persephone-necklace-silver?variant=55996835856761",
      productGoldVariantId: "55992555340153",
      productSilverVariantId: "55996835856761",
      productGoldLabel: "Gold",
      productSilverLabel: "Silver",
      aboutYou: "There is more to you than people see at first. You feel deeply, notice subtle shifts, and often process things internally before expressing them. Your strength isn’t obvious — it’s layered. You’ve changed, evolved, and rebuilt yourself more times than most people realize.",
      aboutGoddess: "Persephone represents emotional depth, inner evolution, and the power of transformation. She teaches that softness is not weakness, and that going inward is where real change begins. When this energy leads you, you don’t just grow — you transform.",
      resultIntro: "You are guided by depth, intuition, and quiet transformation."
    },

    medusa: {
      name: "Medusa",
      keywords: ["Protection", "Strength", "Sacred Boundaries"],
      image: "goddess-medusa-hero.webp",
      medallionImage: "medusa-medallion.webp",
      aboutYouImage: "goddess-medusa-about-you.webp",
      aboutGoddessImage: "goddess-medusa-about-goddess.webp",
      productGoldHandle: "medusa-necklace",
      productSilverHandle: "medusa-necklace-silver",
      productGoldUrl: "https://apolloniajewelry.com/products/medusa-necklace?variant=55992568709497",
      productSilverUrl: "https://apolloniajewelry.com/products/medusa-necklace-silver?variant=55996834480505",
      productGoldVariantId: "55992568709497",
      productSilverVariantId: "55996834480505",
      productGoldLabel: "Gold",
      productSilverLabel: "Silver",
      aboutYou: "You feel things instantly. You can read energy, sense intention, and recognize when something is off without needing proof. You’ve learned not to ignore that. There is a protective force in you — one that doesn’t let people cross you easily anymore. And that’s where your power comes from.",
      aboutGoddess: "Medusa represents protection, truth, and unapologetic strength. She is not here to be softened or made acceptable. She exists to protect what is sacred. When this energy leads you, you stop abandoning yourself — and that changes everything.",
      resultIntro: "You are guided by instinct, strength, and powerful boundaries."
    },

    cleopatra: {
      name: "Cleopatra",
      keywords: ["Presence", "Sovereignty", "Magnetism"],
      image: "goddess-cleopatra-hero.webp",
      medallionImage: "cleopatra-medallion.webp",
      aboutYouImage: "goddess-cleopatra-about-you.webp",
      aboutGoddessImage: "goddess-cleopatra-about-goddess.webp",
      productGoldHandle: "cleopatra-necklace",
      productSilverHandle: "cleopatra-necklace-silver",
      productGoldUrl: "https://apolloniajewelry.com/products/cleopatra-necklace?variant=55992558420345",
      productSilverUrl: "https://apolloniajewelry.com/products/cleopatra-necklace-silver?variant=55996835004793",
      productGoldVariantId: "55992558420345",
      productSilverVariantId: "55996835004793",
      productGoldLabel: "Gold",
      productSilverLabel: "Silver",
      aboutYou: "You’re not meant to be invisible. There’s something about you that naturally stands out — not because you try, but because you own who you are. You feel most aligned when you are fully expressed, fully seen, and no longer holding yourself back for others.",
      aboutGoddess: "Cleopatra represents sovereignty, confidence, and magnetic presence. She doesn’t ask for permission — she defines the space she’s in. Her power comes from knowing her worth and never negotiating it. When you embody this energy, you stop shrinking and start leading.",
      resultIntro: "You are guided by presence, power, and self-worth."
    },

    aphrodite: {
      name: "Aphrodite",
      keywords: ["Desire", "Radiance", "Connection"],
      image: "goddess-aphrodite-hero.webp",
      medallionImage: "aphrodite-medallion.webp",
      aboutYouImage: "goddess-aphrodite-about-you.webp",
      aboutGoddessImage: "goddess-aphrodite-about-goddess.webp",
      productGoldHandle: "aphrodite-necklace",
      productSilverHandle: "aphrodite-necklace-silver",
      productGoldUrl: "https://apolloniajewelry.com/products/aphrodite-necklace?variant=55992553406841",
      productSilverUrl: "https://apolloniajewelry.com/products/aphrodite-necklace-silver?variant=55996836020601",
      productGoldVariantId: "55992553406841",
      productSilverVariantId: "55996836020601",
      productGoldLabel: "Gold",
      productSilverLabel: "Silver",
      aboutYou: "You are deeply connected to what feels alive. You notice beauty, energy, chemistry — the invisible layer between people. You don’t just experience life logically, you feel it. And when you’re fully in that energy, you become magnetic without trying.",
      aboutGoddess: "Aphrodite represents attraction, emotional intelligence, and feminine radiance. She teaches that desire is a guide, not a distraction. When this energy leads you, you don’t chase — you attract.",
      resultIntro: "You are guided by desire, connection, and emotional energy."
    },

     hecate: {
      name: "Hecate",
      keywords: ["Magic", "Wisdom", "Mystery"],
      image: "goddess-hecate-hero.webp",
      medallionImage: "hecate-medallion.webp",
      aboutYouImage: "goddess-hecate-about-you.webp",
      aboutGoddessImage: "goddess-hecate-about-goddess.webp",
      productGoldHandle: "hecate-necklace",
      productSilverHandle: "hecate-necklace-silver",
      productGoldUrl: "https://apolloniajewelry.com/collections/hecate",
      productSilverUrl: "https://apolloniajewelry.com/collections/hecate",
      productGoldVariantId: "",
      productSilverVariantId: "",
      productGoldLabel: "Gold",
      productSilverLabel: "Silver",
      aboutYou: "You have walked through your own darkness and come out knowing things no one else dares to understand. You do not fear the unknown. You have learned to read it. There is a depth in you that most people sense before they understand it. You hold secrets with a steadiness that comes from having faced everything and chosen yourself anyway.",
      aboutGoddess: "Hecate stands at the crossroads where the night is deepest and the stars burn coldest. She is the keeper of secrets, the guide through transformation, the voice that speaks clearly when the world falls silent. She does not fear the unknown. She rules it. Ancient. Sovereign. Untouchable.",
      resultIntro: "You are guided by magic, ancient wisdom, and the power of the unseen."
    },

    artemis: {
      name: "Artemis",
      keywords: ["Independence", "Protection", "Wild Freedom"],
      image: "goddess-artemis-hero.webp",
      medallionImage: "artemis-medallion.webp",
      aboutYouImage: "goddess-artemis-about-you.webp",
      aboutGoddessImage: "goddess-artemis-about-goddess.webp",
      productGoldHandle: "artemis-necklace",
      productSilverHandle: "artemis-necklace-silver",
      productGoldUrl: "https://apolloniajewelry.com/collections/artemis",
      productSilverUrl: "https://apolloniajewelry.com/collections/artemis",
      productGoldVariantId: "",
      productSilverVariantId: "",
      productGoldLabel: "Gold",
      productSilverLabel: "Silver",
      aboutYou: "You have never needed permission to be who you are. You move through the world on your own terms. You guard your energy like sacred ground and answer to no one. Your independence is not distance. It is clarity. You know your worth without needing it confirmed.",
      aboutGoddess: "Artemis ran before she was taught to walk. She answered to no one and protected everything she loved with fierce precision. She never waited to be chosen. She chose herself. Not cold, but clear. Not distant, but free. When you wear Artemis you carry the stillness of the moon and the force of a woman who has never needed permission. Untamed. Luminous. Unapologetically herself.",
      resultIntro: "You are guided by independence, instinct, and the freedom to be exactly who you are."
    }
  },

  questions: [
  {
    id: "unclear_feelings",
    question: "When something feels unclear, what happens naturally?",
    answers: [
      {
        text: "I pause and observe before I decide what it means.",
        image: "athena-1.webp",
        scores: { hecate: 3, cleopatra: 1 }
      },
      {
        text: "I go inward and try to understand what I'm feeling first.",
        image: "persephone-1.webp",
        scores: { hecate: 3, aphrodite: 1 }
      },
      {
        text: "I instantly sense if something is off and adjust my energy.",
        image: "medusa-1.webp",
        scores: { medusa: 3, hecate: 1 }
      },
      {
        text: "I take control so things don't spiral.",
        image: "cleopatra-1.webp",
        scores: { cleopatra: 3, medusa: 1 }
      },
      {
        text: "I stay connected to what still feels right and alive.",
        image: "aphrodite-1.webp",
        scores: { aphrodite: 3, cleopatra: 1 }
      }
    ]
  },
  {
    id: "first_impression",
    question: "What do people usually assume about you at first — before they really know you?",
    answers: [
      {
        text: "That I'm distant or hard to read.",
        image: "athena-2.webp",
        scores: { hecate: 3, medusa: 1 }
      },
      {
        text: "That I'm quiet or reserved.",
        image: "persephone-2.webp",
        scores: { aphrodite: 4 }
      },
      {
        text: "That I'm intense or intimidating.",
        image: "medusa-2.webp",
        scores: { medusa: 3, cleopatra: 1 }
      },
      {
        text: "That everything comes easily to me.",
        image: "cleopatra-2.webp",
        scores: { cleopatra: 3, aphrodite: 1 }
      },
      {
        text: "That I'm independent and self-contained.",
        image: "aphrodite-2.webp",
        scores: { medusa: 3, cleopatra: 1 }
      }
    ]
  },
  {
    id: "true_connection",
    question: "What makes you feel truly connected to someone?",
    answers: [
      {
        text: "When they understand me without needing constant explanation.",
        image: "athena-3.webp",
        scores: { hecate: 3, aphrodite: 1 }
      },
      {
        text: "When there's emotional depth, not just surface interaction.",
        image: "persephone-3.webp",
        scores: { aphrodite: 3, hecate: 1 }
      },
      {
        text: "When I feel safe enough to fully open.",
        image: "medusa-3.webp",
        scores: { medusa: 3, aphrodite: 1 }
      },
      {
        text: "When there's mutual respect and admiration.",
        image: "cleopatra-3.webp",
        scores: { aphrodite: 3, cleopatra: 1 }
      },
      {
        text: "When there's no need to perform or explain myself.",
        image: "aphrodite-3.webp",
        scores: { hecate: 3, medusa: 1 }
      }
    ]
  },
  {
    id: "crossed_boundary",
    question: "When someone crosses a line with you, what shifts first?",
    answers: [
      {
        text: "I become very clear and direct.",
        image: "athena-4.webp",
        scores: { medusa: 3, cleopatra: 1 }
      },
      {
        text: "I pull back and process before reacting.",
        image: "persephone-4.webp",
        scores: { hecate: 3, aphrodite: 1 }
      },
      {
        text: "I feel it instantly and shut down access.",
        image: "medusa-4.webp",
        scores: { medusa: 3, cleopatra: 1 }
      },
      {
        text: "I hold my ground without explaining too much.",
        image: "cleopatra-4.webp",
        scores: { cleopatra: 3, medusa: 1 }
      },
      {
        text: "I go quiet and withdraw into myself.",
        image: "aphrodite-4.webp",
        scores: { hecate: 3, aphrodite: 1 }
      }
    ]
  },
  {
    id: "right_attention",
    question: "What kind of attention actually feels right to you?",
    answers: [
      {
        text: "Being respected for how I think and carry myself.",
        image: "athena-5.webp",
        scores: { cleopatra: 3, hecate: 1 }
      },
      {
        text: "Being understood even when I say little.",
        image: "persephone-5.webp",
        scores: { aphrodite: 3, hecate: 1 }
      },
      {
        text: "Being taken seriously and not underestimated.",
        image: "medusa-5.webp",
        scores: { medusa: 3, cleopatra: 1 }
      },
      {
        text: "Being seen as powerful and unforgettable.",
        image: "cleopatra-5.webp",
        scores: { cleopatra: 3, aphrodite: 1 }
      },
      {
        text: "Not needing attention — being enough on my own.",
        image: "aphrodite-5.webp",
        scores: { medusa: 3, hecate: 1 }
      }
    ]
  },
  {
    id: "hidden_truth",
    question: "What is something about you that most people don't see right away?",
    answers: [
      {
        text: "How much I observe and process internally.",
        image: "athena-6.webp",
        scores: { hecate: 3, cleopatra: 1 }
      },
      {
        text: "How deeply I feel beneath the surface.",
        image: "persephone-6.webp",
        scores: { aphrodite: 3, hecate: 1 }
      },
      {
        text: "How sensitive I am underneath my strength.",
        image: "medusa-6.webp",
        scores: { aphrodite: 4 }
      },
      {
        text: "How much pressure I put on myself.",
        image: "cleopatra-6.webp",
        scores: { cleopatra: 3, medusa: 1 }
      },
      {
        text: "How much I have seen and survived alone.",
        image: "aphrodite-6.webp",
        scores: { hecate: 3, medusa: 1 }
      }
    ]
  },
  {
    id: "wanting_something",
    question: "When you really want something, what happens first?",
    answers: [
      {
        text: "I check if it truly aligns before moving.",
        image: "athena-7.webp",
        scores: { hecate: 3, aphrodite: 1 }
      },
      {
        text: "I feel it quietly and let it build.",
        image: "persephone-7.webp",
        scores: { aphrodite: 3, hecate: 1 }
      },
      {
        text: "I become focused and hard to distract.",
        image: "medusa-7.webp",
        scores: { medusa: 3, cleopatra: 1 }
      },
      {
        text: "I decide and move toward it.",
        image: "cleopatra-7.webp",
        scores: { cleopatra: 3, medusa: 1 }
      },
      {
        text: "I follow what feels magnetic.",
        image: "aphrodite-7.webp",
        scores: { aphrodite: 3, cleopatra: 1 }
      }
    ]
  },
  {
    id: "what_shaped_you",
    question: "Looking back, what has shaped you the most?",
    answers: [
      {
        text: "Learning to trust my own judgment.",
        image: "athena-8.webp",
        scores: { cleopatra: 3, hecate: 1 }
      },
      {
        text: "Growing through change and inner shifts.",
        image: "persephone-8.webp",
        scores: { aphrodite: 4 }
      },
      {
        text: "Learning to protect myself.",
        image: "medusa-8.webp",
        scores: { medusa: 3, hecate: 1 }
      },
      {
        text: "Refusing to shrink or forget my worth.",
        image: "cleopatra-8.webp",
        scores: { cleopatra: 3, medusa: 1 }
      },
      {
        text: "Walking through darkness and coming out different.",
        image: "aphrodite-8.webp",
        scores: { hecate: 3, medusa: 1 }
      }
    ]
  },
  {
    id: "becoming_woman",
    question: "What feels most true about the woman you are becoming?",
    answers: [
      {
        text: "More clear, more self-trusting.",
        image: "athena-9.webp",
        scores: { cleopatra: 3, hecate: 1 }
      },
      {
        text: "More intuitive, more grounded within.",
        image: "persephone-9.webp",
        scores: { aphrodite: 3, hecate: 1 }
      },
      {
        text: "Stronger, more protected.",
        image: "medusa-9.webp",
        scores: { medusa: 3, cleopatra: 1 }
      },
      {
        text: "More visible, more self-assured.",
        image: "cleopatra-9.webp",
        scores: { cleopatra: 3, aphrodite: 1 }
      },
      {
        text: "More free. Answering to no one but myself.",
        image: "aphrodite-9.webp",
        scores: { medusa: 3, hecate: 1 }
      }
    ]
  }
]
};